export default __webpack_public_path__ + "static/media/solution_77.aef4a600.svg";